import Avatar from '@/components/ui/avatar/avatar';
export default Avatar;
